import React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import style from "./style.css";
import { Flex, SVGButton } from "/app/src/component";

import ConversationHeader from "./Conversation";
import StandardHeader from "./Standard";
import NotificationDisplay from "./NotificationDisplay";
import ProfileDisplay from "./ProfileDisplay";

import SystemModel from "/app/src/model/System/model";
import NotificationModel from "/app/src/model/Notification/model";
import { SystemSelector } from "/app/src/model/System";
import EmployeeSelector from "/app/src/model/Employee/selector";
import { FAQSelector } from "/app/src/model/selectors";
import { NotificationSelector } from "/app/src/model/Notification";
import { history } from "/app/src/store";
import UserModel from "/app/src/model/User/model";
import SearchField from "./SearchField";
import Banner from "./Banner";

//SearchField also uses these constants.
const SEARCH_CUSTOMER = "customer";
const SEARCH_TICKET = "ticket";

class NavBar extends React.Component {
  constructor(props) {
    super(props);
    this._renderMain = this._renderMain.bind(this);
    this.__menuButtonHandler = this.__menuButtonHandler.bind(this);
    this._onClickNotification = this._onClickNotification.bind(this);
    this._searchButtonHandler = this._searchButtonHandler.bind(this);
    this._handleSearchInput = this._handleSearchInput.bind(this);
    this._handleKeyPress = this._handleKeyPress.bind(this);
    this._changeSearchType = this._changeSearchType.bind(this);
    this._search = this._search.bind(this);
    this._onClickProfile = this._onClickProfile.bind(this);
    this.onClickCloseModal = this.onClickCloseModal.bind(this);

    //Set proper app state in case user hits refresh. Relevant for radio button state.
    const route = this.props.route;
    let searchType = null;
    if (route.indexOf("customerTicket") !== -1) searchType = SEARCH_TICKET;
    else searchType = SEARCH_CUSTOMER;

    this.state = {
      notificationDisplay: false,
      searchInput: "",
      displaySearchField: false,
      searchType: searchType,
      profileDisplay: false,
    };
  }

  _handleSearchInput(e) {
    this.setState({ searchInput: e.target.value });
  }

  _changeSearchType(buttonName) {
    if (buttonName === "customerSearch") {
      this.setState({ searchType: SEARCH_CUSTOMER });
      this._search(SEARCH_CUSTOMER);
    } else if (buttonName === "ticketSearch") {
      this.setState({ searchType: SEARCH_TICKET });
      this._search(SEARCH_TICKET);
    }
  }

  _searchButtonHandler(e) {
    //reference to focus in in searchField component
    if (!this.state.displaySearchField) this.searchField.focus();
    this.setState((prevState) => ({
      displaySearchField: !prevState.displaySearchField,
    }));
  }

  _renderMain() {
    switch (this.props.params[0]) {
      case "conversation":
        return <ConversationHeader room={this.props.params[1]} />;
      case "clientChat":
        switch (this.props.params[1]) {
          case "customization":
            return (
              <StandardHeader
                title="Utseende"
                subTitle="Välj hur er Client Chat ska se ut på hemsidan."
                fill="#f64b7f"
                imgSrc="/images/Menu_ClientChatCustom_L.svg"
              />
            );
          case "faq":
            switch (this.props.params[2]) {
              case "helpdesk":
                let subTitle = "Bygg din kunskapsbank med frågor och svar.";
                switch (this.props.params[3]) {
                  case "category":
                    const filteredCats = this.props.categories.filter(
                      (category) =>
                        category.get("id") ===
                        parseInt(this.props.params[4], 10)
                    );
                    if (!filteredCats.isEmpty()) {
                      subTitle = filteredCats.getIn([0, "category"], "");
                    }
                    break;
                  case "feedback":
                    subTitle = "Här ser du frågor med mottagen feedback";
                    break;
                  default:
                    break;
                }
                return (
                  <StandardHeader
                    title={
                      <span>
                        Helpdesk
                        <sup style={{ color: "purple", marginLeft: "1px" }}>
                          PRO
                        </sup>
                      </span>
                    }
                    subTitle={subTitle}
                    fill="#f64b7f"
                    imgSrc="/images/Menu_ClientChat_Helpdesk_L.svg"
                  />
                );
              case "faq":
              default:
                return (
                  <StandardHeader
                    title="Frågor och Svar"
                    subTitle="Lägg till, ta bort och redigera din FAQ."
                    fill="#f64b7f"
                    imgSrc="/images/Menu_ClientChatFAQ_L.svg"
                  />
                );
            }
          case "autoMessage":
            return (
              <StandardHeader
                title="Automeddelande"
                subTitle="Skräddarsy ett automeddelande till dina besökare."
                fill="#f64b7f"
                imgSrc="/images/Menu_ClientChatAutomessage_L.svg"
              />
            );
          case "formular":
            return (
              <StandardHeader
                title="Uppgifter & Återkoppling"
                subTitle="Konfigurera automatiska formulär."
                fill="#f64b7f"
                imgSrc="/images/Menu_ClientChatForms.svg"
              />
            );
          case "exchange":
            return (
              <StandardHeader
                title="Växelsystem"
                subTitle="Organisera er verksamhet."
                fill="#f64b7f"
                imgSrc="/images/Menu_SwitchSystem_L.svg"
              />
            );
          case "rating":
            return (
              <StandardHeader
                  title="Betyg & Omdömen"
                  subTitle="Konfigurera omdömen."
                  fill="#f64b7f"
                  imgSrc="/images/Menu_ratings.svg"
                />
            );
          default:
            return (
              <StandardHeader
                title="Offlineinställningar"
                subTitle="Konfigurera och schemalägg Offlineformulär."
                fill="#f64b7f"
                imgSrc="/images/Menu_ClientChatShowHide_L.svg"
              />
            );
        }
      case "history":
        return (
          <StandardHeader
            title="Historik"
            subTitle="Alla avklarade ärenden"
            fill="#f6934b"
            imgSrc="/images/Menu_History.svg"
          />
        );
      case "searchTicket":
      case "searchCustomer":
        return <StandardHeader title="Sökresultat" subTitle="" />;
      case "user":
        switch (this.props.params[1]) {
          case "profilepicture":
            return (
              <StandardHeader
                title="Min profil"
                subTitle="Redigera namn och profilbild."
                imgSrc="/images/Menu_ProfileProfile_L.svg"
                fill="#76b376"
              />
            );
          case "changepassword":
            return (
              <StandardHeader
                title="Lösenord"
                subTitle="Här kan du byta ditt lösenord."
                imgSrc="/images/Menu_ProfilePassword.svg"
                fill="#76b376"
              />
            );
          case "notifications":
            return (
              <StandardHeader
                title="Ljud och aviseringar"
                subTitle="Inställningar för ljud och aviseringar"
                imgSrc="/images/Menu_ProfileNotifications.svg"
                fill="#76b376"
              />
            );
          default:
            return <StandardHeader title="clientChat" subTitle="#TODO" />;
        }
      case "companySettings":
        switch (this.props.params[1]) {
          case "employee":
            return (
              <StandardHeader
                title="Hantera Medarbetare"
                subTitle="Lägg till användare och hantera behörighet."
                fill="#404040"
                imgSrc="/images/Menu_CompanySettingsEmployees.svg"
              />
            );
          case "payment":
            return (
              <StandardHeader
                title="Faktureringsuppgifter"
                subTitle="Redigera dina kontouppgifter."
                fill="#404040"
                imgSrc="/images/Menu_CompanySettingsInfo.svg"
              />
            );
          case "invoice":
            return (
              <StandardHeader
                title="Fakturor"
                subTitle={"Här kan du se och ladda ner dina fakturor."}
                fill="#404040"
                imgSrc="/images/Menu_CompanySettingsPayment_L.svg"
              />
            );
          case "installation":
            return (
              <StandardHeader
                title="Installation"
                subTitle={"Här kan du kopiera koden för din hemsida."}
                fill="#404040"
                imgSrc="/images/Menu_CompanySettingsInstall.svg"
              />
            );
          case "upgrade":
            return (
              <StandardHeader
                title="Prisplan"
                subTitle={"Välj din prisplan"}
                fill="#404040"
                imgSrc="/images/ShootingStar_L.svg"
              />
            );
          case "endSubscription":
            return (
              <StandardHeader
                title="Avsluta Jibber"
                subTitle=""
                fill="#404040"
              />
            );
          default:
            return (
              <StandardHeader
                title="clientChat"
                subTitle={"#TODO"}
                fill="#404040"
                imgSrc="/images/Menu_CompanySettingsEmployees.svg"
              />
            );
        }
      case "chatSettings":
        return (
          <StandardHeader
            title="Snabbsvar"
            subTitle="Lägg till, ta bort och redigera svar på vanliga frågor."
            fill="#a25cbf"
            imgSrc="/images/Menu_ChatsettingsQuickResponse.svg"
            />
        );
      case "tutorial":
        return (
          <StandardHeader title="Tutorial" subTitle="Kom igång med Jibber!" />
        );
      default:
        return (
          <StandardHeader
            title="Översikt och live-statistik"
            imgSrc="/images/Menu_Overview_L.svg"
            fill="#2ea2d2"
          />
        );
    }
  }

  __menuButtonHandler() {
    this.props.dispatch(SystemModel.menuToogle(!this.props.menuToogle));
  }

  _onClickNotification() {
    const notificationId = this.props.notifications.getIn([0, "id"]);
    this.setState({ notificationDisplay: !this.state.notificationDisplay });
    this.props.dispatch(NotificationModel.setToRead(notificationId));
  }

  _search(searchType) {
    if (!searchType) searchType = this.state.searchType;

    const tags = this.state.searchInput.trim();
    if (tags === "") return;

    //Not splitting 'tags' to avoid commas in URL
    this.props.dispatch(UserModel.searchBy(tags.split(" ")));
    if (searchType === SEARCH_TICKET)
      history.push({
        pathname: "/searchTicket",
        search: `?terms=${tags}`,
      });
    else
      history.push({
        pathname: "/searchCustomer",
        search: `?terms=${tags}`,
      });
  }

  _handleKeyPress(e) {
    if (e.key !== "Enter") return;

    let value = this.state.searchInput;
    if (!value) return;

    let entryBody = value.trim();
    if (!entryBody) return;

    this._search();
    e.preventDefault();
  }

  _onClickProfile() {
    this.setState({ profileDisplay: !this.state.profileDisplay });
  }

  onClickCloseModal(modal) {
    var newState = {};
    newState[String(modal)] = false;
    this.setState(newState);
  }

  _renderMenu() {
    let menuToogle = this.props.menuToogle;
    const notifications = this.props.notifications;
    return (
      <Flex
        className={style.MainPanelHeaderMenu}
        hAlignContent="right"
        vAlignContent="center"
        grow
      >
        <Flex grow={1} hAlignContent="right">
          <Flex position="relative">
            <Flex vAlignContent="center">
              <div ref={(node) => (this.searchRef = node)}>
                <Flex vAlignContent="center">
                  <SearchField
                    onChange={this._handleSearchInput}
                    onKeyPress={this._handleKeyPress}
                    value={this.state.searchInput}
                    display={this.state.displaySearchField}
                    searchType={this.state.searchType}
                    changeSearchClick={this._changeSearchType}
                    searchRef={
                      this
                        .searchRef /*evil stop propagation hack on top of z-index hack*/
                    }
                    searchButtonRef={
                      this
                        .searchButtonRef /*evil stop propagation hack on top of z-index hack*/
                    }
                    onClickCloseModal={this.onClickCloseModal}
                    ref={(node) => (this.searchField = node)}
                  />
                </Flex>
              </div>
            </Flex>
            <Flex vAlignContent="center">
              <div
                className={style.searchButton}
                ref={(node) => (this.searchButtonRef = node)}
              >
                <SVGButton
                  src="/images/Search.svg"
                  color="black"
                  hover="darkblue"
                  onClick={this._searchButtonHandler}
                  mr="10px"
                  height="50px"
                />
              </div>
            </Flex>
          </Flex>
          <Flex>
            <SVGButton
              src="/images/Menu.svg"
              color="black"
              hover="darkblue"
              active={menuToogle}
              mr="10px"
              onClick={this.__menuButtonHandler}
              height="50px"
            />
          </Flex>
          <div ref={(node) => (this.notificationRef = node)}>
            <Flex position="relative">
              <SVGButton
                src="/images/Notification.svg"
                color="black"
                hover="darkblue"
                onClick={this._onClickNotification}
                height="50px"
                active={this.state.notificationDisplay}
              />
              {this.props.numberUnread > 0 && (
                <Flex
                  position="absolute"
                  w="15px"
                  h="15px"
                  borderRadius="50%"
                  hAlignContent="center"
                  right="0px"
                  top="6px"
                  bg="red"
                ></Flex>
              )}
              {this.state.notificationDisplay && (
                <NotificationDisplay
                  notifications={notifications}
                  onClickCloseModal={this.onClickCloseModal}
                  notificationRef={this.notificationRef}
                />
              )}
            </Flex>
          </div>
        </Flex>
        <Flex position="relative">
          <SVGButton
            src="/images/Help.svg"
            color="black"
            hover="darkblue"
            mr="10px"
            onClick={() => {
              window.open("https://jibber.se/hjalp");
            }}
            height="50px"
          />
        </Flex>
        <div ref={(node) => (this.profileRef = node)}>
          <Flex onClick={this._onClickProfile} hAlignContent="right" mr="15px">
            <img
              className={style.PreviewImage}
              src={this.props.userImageUrl}
              alt="user"
            />
          </Flex>
          {this.state.profileDisplay && (
            <ProfileDisplay
              onClickCloseModal={this.onClickCloseModal}
              profileRef={this.profileRef}
            />
          )}
        </div>
      </Flex>
    );
  }

  render() {
    return (
      <Flex height="100%" basis="100%" className={style.NavBar}>
        <Flex basis="25%" borderRight="1px solid lightgrey">
          <Banner />
        </Flex>
        <Flex basis="50%">{this._renderMain()}</Flex>
        <Flex basis="25%">{this._renderMenu()}</Flex>
      </Flex>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let userId = state.getIn(["user", "login", "id"]);
  let user = EmployeeSelector.getById(state, userId);

  let userImageUrl = EmployeeSelector.getProfilePicture(user);
  let menuToogle = state.getIn(["system", "menu", "toogle"]);

  let route = SystemSelector.getRoute(state);
  let params = SystemSelector.getParams(state);

  const notifications = NotificationSelector.getNotifications(state);
  const numberUnread = NotificationSelector.getNumberUnread(notifications);

  const categories = FAQSelector.getCategories(state);

  return {
    userImageUrl: userImageUrl,
    menuToogle: menuToogle,
    params: params,
    notifications: notifications,
    numberUnread: numberUnread,
    route: route,
    categories: categories,
  };
}

export default withRouter(connect(mapStateToProps)(NavBar));



// WEBPACK FOOTER //
// ./src/layout/Dashboard/Header/index.js